import {JsToClientCommand} from '../jsToClientCommand';
import {ClientCommands} from '../clientCommands';

export type SetGoogleAccessTokenCommandParams = {
    accessToken: string
};

export class SetGoogleAccessTokenCommand extends JsToClientCommand<SetGoogleAccessTokenCommandParams> {
    constructor(params: SetGoogleAccessTokenCommandParams) {
        super(ClientCommands.SET_GOOGLE_ACCESS_TOKEN, params);
    }
}
